export default __webpack_public_path__ + "static/media/aboutUs.4e43840b.webp";